<template>
  <div id="top-header" @click="$emit('onBack')">
    <div
      style="font-size: 46px; font-family: 'PangMenFont'"
      class="pt-16 flex justify-center"
    >
      <!-- 构建居家社区机构相协调，医养康养相结合的养老服务体系 -->
    </div>
    <div class="flex justify-between border items-center">
      <div class="decoration-content">
        <div class="flex items-center"></div>
      </div>

      <div class="center-title">
        <img class="logo" src="../../assets/imgs/dadukou-logo.jpg" alt="" />
        大渡口区社区居家智慧养老服务平台
        <div class="mx-4" style="margin-top: -8px">|</div>
        <span @click.stop="handleGowebview">
          智慧养老综合服务平台
        </span>
      </div>
      <!-- <div class="absolute right-0" @click.stop="handleGowebview">
        <div class="flex items-center text-red-500  pr-10 font-weight" style="font-size: 30px;">
          智慧养老综合服务平台
        </div>
      </div> -->
      <div class="decoration-content">
        <div class="flex items-center"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopHeader",
  data() {
    return {};
  },
  methods: {
    handleGowebview() {
      // this.$router.push({
      //   path: "/webview",
      // });
      window.open("http://111.10.70.56:3398/website");
    }
  },
  mounted() {
    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement === null) {
        console.log("Exited fullscreen");
      } else {
        console.log("Entered fullscreen");
      }
    });
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: "PangMenFont";
  src: url("../../assets/font/pangmen.otf") format("opentype");
}
.my-font-text {
  font-family: "PangMenFont", sans-serif;
}
#top-header {
  color: #bb5d59 !important;
  position: relative;
  width: 100%;
  height: 160px;
  // display: flex;
  // justify-content: space-between;
  flex-shrink: 0;
  // background: #e0ecfa;

  // background-image: url("./img/top-bg.png");
  background-size: 100% 100%;

  .center-title {
    font-size: 46px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .logo {
      width: 94px;
      height: 94px;
    }
  }
}
</style>
